import classNames from 'classnames/bind';
import React, { CSSProperties } from 'react';
import styles from './Loader.module.scss';

const cx = classNames.bind(styles);

type LoaderProps = {
  spinnerSize?: string;
  color?: 'primary' | 'tertiary';
  className?: string;
  text?: string | null;
  position?: 'center';
  dataTestId?: string;
};

const Loader = ({
  spinnerSize,
  color = 'tertiary',
  className,
  text = 'Loading data...',
  position,
  dataTestId = 'loader',
}: LoaderProps): React.ReactElement => {
  const style = {
    '--cs-size': spinnerSize,
  } as CSSProperties;
  return (
    <div className={cx('body', `${position}`, className)} data-testid={dataTestId}>
      <div className={cx('wrapper', `${position}`)}>
        <div className={cx('spinner', `${color}`)} style={style} data-testid="circular-loader" />
        {text && <span className={cx('text', `${color}`)}>{text}</span>}
      </div>
    </div>
  );
};

export default Loader;
